import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { markdownParagraphSize } from "../../components/markdown/markdownSizes";
import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const paragraphBlockVariants = cva([
    "s-whitespace-pre-wrap s-break-words s-font-normal first:s-pt-0 last:s-pb-0",
], {
    variants: {
        compactSpacing: {
            true: ["s-py-0"],
            false: ["s-py-1 @md:s-pt-2 @md:s-pb-[10px] @md:s-leading-relaxed"],
        },
    },
});
export const ParagraphBlock = memo(({ children }) => {
    const { textColor, forcedTextSize, compactSpacing } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownParagraphSize;
    return (React.createElement("div", { className: cn(paragraphBlockVariants({ compactSpacing }), textSize, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node));
ParagraphBlock.displayName = "ParagraphBlock";
//# sourceMappingURL=ParagraphBlock.js.map